import {Box, Typography} from '@mui/material'
import {Fragment} from 'react'
import FormikSelect from 'shared/FormikSelect'
import LabelAdder from './LabelAdder'
import './index.scss'

interface OptionGroupProps {
    formik: any
    contactWith?: string
    cpsOptions?: unknown[]
    carrierOptions?: unknown[]
}

const OptionGroup = ({
    formik,
    contactWith,
    cpsOptions,
    carrierOptions
}: OptionGroupProps) => {
    const issueDropdown = (id, options, placeholder) => (
        <Fragment>
            <FormikSelect
                id={id}
                formik={formik}
                placeholder={placeholder}
                options={options}
                className='formik-select'
                MenuClassName='contact-dropdown'
            />
        </Fragment>
    )

    if (contactWith === 'Contact CPS') {
        return (
            <Fragment>
                <Typography variant='h6'>
                    <strong>Having a technical problem with the cargo portal?</strong>&nbsp;&nbsp;Contact our support
                    team and we’ll get back to you.
                </Typography>
                <LabelAdder
                    id='issue'
                    input={issueDropdown('issue', cpsOptions, '- Select Issue -')}
                    showAsterik={true}
                    label='What is your issue related to?'
                />
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Typography variant='h6'>
                    <strong>Need to contact one of our airline carriers?</strong>&nbsp;&nbsp;Complete this form to
                    immediately send your question to a partner representative.
                </Typography>
                <Box className='side-by-side'>
                    <LabelAdder
                        id='carrier'
                        input={issueDropdown('carrier', carrierOptions, '- Select Carrier -')}
                        label='Which carrier should be contacted?'
                        showAsterik={true}
                    />
                    <LabelAdder
                        id='issue'
                        input={issueDropdown('issue', cpsOptions, '- Select Issue -')}
                        label='What is your issue related to?'
                        showAsterik={true}
                    />
                </Box>
            </Fragment>
        )
    }
}

OptionGroup.defaultProps = {
    contactWith: 'cps'
}

export default OptionGroup
